import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { Table, TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { DoService } from '../../services/do-service/do.service';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Router, RouterLink } from '@angular/router';
import { MenuService } from '../../layout/service/menu.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-rechercher-do',
  imports: [TableModule,
            BreadcrumbModule,
            SelectModule,
            InputIconModule,
            InputTextModule,
            ToastModule,
            DialogModule,
            ConfirmDialogModule,
            CommonModule,
            ButtonModule,
            IconFieldModule,
            MessageModule],
  templateUrl: './rechercher-do.component.html',
  styleUrl: './rechercher-do.component.scss',
  providers: [ConfirmationService,MessageService],
})
export class RechercherDoComponent {
    @ViewChild('dt') dt!: Table;
    @ViewChild('filter') filter!: ElementRef;



    breadcrumbHome = { icon: 'pi pi-home', RouterLink: 'rechercher-do' };
    breadcrumbItems = [{ label: 'Rechercher DO' }];
    doDialog: boolean = false;

    do: any[] = [];
    loading: boolean = true;
    selectedDo: any = null;
    
    

    constructor(private doService: DoService,
                private router: Router,
                private menuService: MenuService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService
    ) {} 

     ngOnInit() {
      this.loadDoData();

       // Restaurer la sélection depuis sessionStorage si elle existe
        const savedSelection = sessionStorage.getItem('selectedDo');
        if (savedSelection) {
            this.selectedDo = JSON.parse(savedSelection);
        }
    }

    loadDoData() {
        this.loading = true;
        this.doService.getAllDo().subscribe({
            next: (data : any) => {
                this.do = data;
                this.loading = false;

             // Après le chargement des données, restaurer la sélection
                if (this.selectedDo) {
                    setTimeout(() => {
                        const foundDo = this.do.find(d => d.code_interne === this.selectedDo.code_interne);
                        if (foundDo) {
                            this.selectedDo = foundDo;
                        }
                    });
                }
            },
            error: (error) => {
                console.error('Error fetching DO data:', error);
                this.loading = false;
            }
        });
    }

      onGlobalFilter(table: Table, event: Event) {
            table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
        }

     // Méthode pour gérer la sélection d'une ligne
    onRowSelect(event: any) {
        this.selectedDo = event.data;
        console.log('DO sélectionnée:', this.selectedDo);
    }

    // Méthode pour valider et naviguer
    validerSelection() {
        if (this.selectedDo) {

             this.messageService.add({
                    severity: 'success',
                    summary: 'Succès',
                    detail: `DO ${this.selectedDo.code_interne} - ${this.selectedDo.Nom} sélectionnée avec succès`,
                    life: 3000,
                });

                // Stocker avant la navigation dans sessionStorage
                sessionStorage.setItem('selectedDo', JSON.stringify(this.selectedDo));
                this.menuService.updateMenu(); // Notifie le menu
                this.router.navigate(['/gestion-do']);
                //console.log('DO sélectionnée et validée:', this.selectedDo.code_interne);
        } else {
            console.warn('Aucune DO sélectionnée');
             this.messageService.add({
                severity: 'warn',
                summary: 'Avertissement',
                detail: 'Veuillez sélectionner une DO avant de valider'
            });
        }
    }
        clear(table: Table) {
        table.clear();
        this.filter.nativeElement.value = '';
    }
}

